import { CabinPrice } from './Types';

export default function byAmount(
  { amount: A }: CabinPrice,
  { amount: B }: CabinPrice,
) {
  return A - B;
}
